var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: _vm.getClasses }, [
    _c(
      "header",
      [
        _c("AlertComponent", {
          attrs: {
            whereIsRendered: _vm.componentWhereIsRenderedAlertComponent,
          },
        }),
        _c("LfHeaderTitleComponent", {
          staticClass: "header-title",
          attrs: { title: _vm.title },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "file-manager-alone" },
      [
        _c("FileManager", {
          attrs: {
            basePath: _vm.basePath,
            idEntityTypeBase: _vm.idEntityTypeBase,
            context: _vm.context,
            mainFolderDescription: "Documentos",
            initialBasePath: _vm.initialBasePath,
            initialPath: _vm.initialPath,
            height: "650",
            canDropFilesOnMainFolder: false,
            canCreateFoldersOnMainFolder: false,
            permissionsEntity: _vm.idEntityTypeBase,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }